import React from 'react';
import { Time, Gift, ShoppingBag, CheckmarkOutlineError } from '@carbon/react/icons';
import StatCard from 'src/components/Employee/StatCard';
import { useMoney } from 'src/hooks/useMoney';

interface EmployeeBonusDetailsProps {}

const EmployeeBonusDetails = React.memo((_props: EmployeeBonusDetailsProps) => {
  const { decimals, format } = useMoney();
  return (
    <div className={'employee-bonus-details'}>
      <h5 className={'section__heading'}>Your Bonus Details</h5>
      <div className="stats">
        <StatCard
          title={'Revenue KPIs'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<ShoppingBag size={36} />}
        />
        <StatCard
          title={'Issue KPIs'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<CheckmarkOutlineError size={36} />}
        />
        <StatCard
          title={'Quick Orders KPIs'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<Time size={36} />}
        />
        <StatCard
          title={'Extra Bonus'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<Gift size={36} />}
        />
      </div>
    </div>
  );
});

export default EmployeeBonusDetails;
